// Session 60: the subject line, a second option and the preview text under
// each newsletter, with a Copy button on each, so the email tool gets the
// lines that earn the open beside the code it gets the body from.
//
// Leena, 2026-10-20: "a suggested title, a potential title, and potential
// preview text underneath each one. The subject lines should be good hooks
// and work well for open rates." The droplet writes them with the
// newsletter's words; the view carries them as newsletter_subject,
// newsletter_subject_alt and newsletter_preview_text (null until written).
import { useState } from 'react';

function CopyButton({ text, what }) {
  const [done, setDone] = useState(false);
  async function copy() {
    try {
      await navigator.clipboard.writeText(text);
      setDone(true);
      setTimeout(() => setDone(false), 1500);
    } catch {
      // no clipboard (an old browser, a blocked permission): the text is
      // right there to select; say so instead of failing quietly
      setDone('select');
      setTimeout(() => setDone(false), 2500);
    }
  }
  return (
    <button type="button" className="link-btn" onClick={copy} aria-label={`Copy the ${what}`}>
      {done === 'select' ? 'Select and copy it' : done ? 'Copied' : 'Copy'}
    </button>
  );
}

export default function NewsletterEmailLines({ row }) {
  if (!row?.newsletter_subject) return null;
  const lines = [
    ['Subject line', row.newsletter_subject],
    ['Another option', row.newsletter_subject_alt],
    ['Preview text', row.newsletter_preview_text],
  ].filter(([, v]) => v);
  return (
    <div className="nl-lines" aria-label="Subject line and preview text for this newsletter">
      {lines.map(([label, value]) => (
        <div className="nl-line" key={label}>
          <span className="nl-line-label">{label}</span>
          <span className="nl-line-text">{value}</span>
          <CopyButton text={value} what={label.toLowerCase()} />
        </div>
      ))}
    </div>
  );
}
